import { Route } from '@angular/router'
import { authGuard, permissionGuard } from '@baboor/baboor-auth'
import { PERMISSIONS } from '@baboor/baboor-models'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type DocumentsRoutes = {
    documents: Route
}

export const documentsRoutes: DocumentsRoutes = {
    documents: {
        path: 'dashboard/documents',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.document.read], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('../page-documents/page-documents.component').then(
                (m) => m.PageDocumentsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
}
